/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line



  function activeMenuResponsive() {
    const header = document.querySelector('header-component.header__wrapper');
    if (!header) return;

    if (window.innerWidth < 768) {
      header.classList.add('active');
    } else {
      header.classList.remove('active');
    }
  }

  // Au chargement
  document.addEventListener('DOMContentLoaded', activeMenuResponsive);

  // À chaque redimensionnement
  window.addEventListener('resize', activeMenuResponsive);




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
